import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from "react-redux";
import { uiActions, visualizerActions } from "../../store";

import PopUpModal from "../PopUpModal/PopUpModal";

import style from './SelectSceneModal.module.css';

export default function SelectSceneModal() {
    const dispatch = useDispatch();

    const activePlan = useSelector((state) => state.visualizer.activeFloorPlanData);
    const activeCommunity = useSelector((state) => state.visualizer.activeCommunity);
    const activeFloorPlanData = useSelector((state) => state.visualizer.activeFloorPlanData);
    const activeFloorPlanSteps = useSelector((state) => state.visualizer.activeFloorPlanSteps);

    // Handle pop up close
    const handleClose = function () {
        dispatch(uiActions.setSceneModalActive(false));
        dispatch(uiActions.setPopUpModalActive(false));
    };

    // Handle scene selection > route user to visualizer
    const handleSceneSelect = function () {

        // let stepsToRemove = [];
        // activeFloorPlanSteps.forEach(step => {
        //     if((step.id == 4 && !activeCommunity.includes('Beachview'))){
        //         stepsToRemove.push(step.id);
        //     }
        // });

        // if(stepsToRemove.length > 0){
        //     //something was removed
        //     console.log('stepsToRemove',stepsToRemove)
        //     dispatch(visualizerActions.updateActiveFloorplanSteps(stepsToRemove));
        // }

        

        dispatch(uiActions.setSceneModalActive(false));
        dispatch(uiActions.setPopUpModalActive(false));
    };

    // Scene data array
    const scenesData = activePlan
        ? [
              { name: 'Exterior', area: 'exterior', specifier: activePlan["exterior"], sel: activePlan["exteriorSel"] },
              { name: 'Kitchen', area: 'kitchen', specifier: activePlan["kitchen"], sel: activePlan["kitchenSel"] },
              { name: 'Bathroom', area: 'bathroom', specifier: activePlan["bathroom"], sel: activePlan["bathroomSel"] }
          ]
        : [];

    // Generate scene options list for the active floorplan
    const scenesList = scenesData.map((scene, index) => (
        <Link onClick={handleSceneSelect}
            key={index}
            to={`/visualizer/floorplan/${activePlan["id"]}/area/${scene.area}/spec/${encodeURIComponent(scene.specifier)}/sel/${scene.sel}`}>
            <div className={style.sceneImg}>
                <img src={`https://core2render.chameleonpower.com/cham/GetImage.ashx?spec=${scene.specifier}&sel=${scene.sel}&type=base&size=300`} alt={scene.name + " scene"} />
            </div>
            <span>{scene.name}</span>
        </Link>
    ));

    const communitysList = activeFloorPlanData?.community
        ?.split(',')
        .map((community) => community.trim()) || [];

    // Automatically select the first community and dispatch it
    useEffect(() => {
        if (!activeCommunity && communitysList.length > 0) {
            dispatch(visualizerActions.setActiveCommunity(communitysList[0]));
        }
    }, [communitysList, activeCommunity, dispatch]);

    const handleCommunityChange = (event) => {
        const selectedCommunity = event.target.value.trim();
        dispatch(visualizerActions.setActiveCommunity(selectedCommunity));
    };

    // Render a fallback if activePlan or activeFloorPlanData is missing
    if (!activePlan || !activeFloorPlanData) {
        return (
            <PopUpModal handleClose={handleClose}>
                <div className={style.flexCol}>
                    <h1>Loading...</h1>
                </div>
            </PopUpModal>
        );
    }

    return (
        <>
            <PopUpModal handleClose={handleClose}>
                <div className={style.flexCol}>
                    <h1>Step 1: Select Your Community</h1>
                    <select
                        className={style.communityList}
                        onChange={handleCommunityChange}
                        value={activeCommunity || communitysList[0]} // Automatically set the first community as selected
                    >
                        {communitysList.map((community, index) => (
                            <option key={index} value={community} className={style.communityOption}>
                                {community}
                            </option>
                        ))}
                    </select>
                </div>
                <h1>Step 2: Choose a {activePlan["name"]} Floor Plan Scene</h1>
                <div className={style.content}>{scenesList}</div>
            </PopUpModal>
        </>
    );
}
